( function ( $ ) {
	'use strict';

	$('.home-references-slider').lightSlider({
		item:4,
		slideMargin: 1,
		pager: true,
		controls: true,
		responsive : [
			{
				breakpoint:1370,
				settings: {
					item:3
				}
			},
			{
				breakpoint:767,
				settings: {
					item:1
				}
			},
			{
				breakpoint:480,
				settings: {
					item:1
				}
			}
		]
	});

	$('.footer-references-slider').lightSlider({
		item:3,
		slideMargin: 20,
		pager: true,
		controls: true,
		responsive : [
			{
				breakpoint:1370,
				settings: {
					item:3
				}
			},
			{
				breakpoint:767,
				settings: {
					item:1
				}
			}
		]
	});

	$('.menu-btn-trigger').click(function (e) {
		e.preventDefault();
		$('body').toggleClass('menu-is-active');
	});

	$('.projects-filter a').click(function(e) {
		e.preventDefault();

		$('.project-item').css({
			display: 'none',
			left: '40px',
			opacity: 0
		});

		var category = $(this).data('category');

		$('.project-item').each(function() {
			var categories = $(this).data('categories');

			if(categories != '') {
				categories = (categories + "").split(',');

				if (categories.includes(category + "")) {
					$(this).show().animate({
						left: '0px',
						opacity: 1
					}, 500);
				}
			}

		});

	});

}( jQuery ) );
